
import { authAPI } from "./../../services/AuthAPI"
import { USER_FETCH, USER_SUCCESS, USER_FAILURE } from "./../types"

export const fetchUser = () => {
    return async dispatch => {
        dispatch({ type: USER_FETCH, payload: null, error: null })
        authAPI.GetUser()
            .then((response) => {
                if (response.status == 200) {
                    dispatch({ type: USER_SUCCESS, payload: response.message, error: null })
                }
                else if (response.status == 401) {
                    dispatch({ type: USER_FAILURE, payload: null, error: response.message })
                    localStorage.removeItem("Token")
                    setTimeout(() => {
                        dispatch({ type: "FORCE_UPDATE", payload: 1 })
                    }, 500);
                }
                else {
                    dispatch({ type: USER_FAILURE, payload: null, error: response.message })
                }
            })
            .catch(error => {
                dispatch({ type: USER_FAILURE, payload: null, error: error.message })
            })
    };
};
